import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";

const FindingGridIncident = props => {
  const { data, remove, preview, edit, isIncidentReport, questions = [] } = props;

  const getEvaluationTitle = (id) => {
    if (!id) return "";
    const q = questions.find(q => String(q.id) === String(id));
    return q?.title || "";
  };

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Hallazgo</th>
            {!isIncidentReport && <th scope="col">Evaluación</th>}
            <th scope="col">Observación</th>
            <th scope="col">Imagenes</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <tr key={item.HallazgoId}>
              <th scope="row">
                <div className="text-nowrap">{item.HallazgoId}</div>
              </th>
              <td>
                <div className="text-nowrap">
                  {item.Hallazgo || "INCIDENTE"}
                </div>
              </td>
              {!isIncidentReport && (
                <td>
                  <div className="text-nowrap">
                    {getEvaluationTitle(item.Evaluacion)}
                  </div>
                </td>
              )}
              <td style={{ maxWidth: 300 }}>
                <div className="text-nowrap text-truncate">
                  {item.Observacion}
                </div>
              </td>
              <td>
                <div className="text-nowrap">{item?.images?.length}</div>
              </td>
              <td>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn bg-primary btn-sm text-white"
                    onClick={() => preview(item)}
                    title="Ver"
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                  {edit && (
                    <button
                      type="button"
                      className="btn bg-warning btn-sm text-white"
                      onClick={() => edit(item)}
                      title="Editar"
                    >
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                  )}
                  {remove && (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => remove(item.HallazgoId)}
                      title="Eliminar"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FindingGridIncident;
